import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { AuthMap } from './auth.action';

const initialState = {
    user: {},
    authToken: null,
    isLoading: false,
    redirectRegisterVerification: false,
    redirectRegisterProfilePage: false,
    redirectLoginVerification: false,
    redirectToDashboard: false,
    verificationField: "",
    flashMessage: "",
    tokenVerified: false,
    uploadDocumentModal: false,
    CMS: {},
    backdrop: true,
    profileDashboard: {
        goldAcquired: 0,
        availableTokens: 0,
        withdarawTokens: 0,
        totalTokensAcquired: 0,
        list: [],
    },
    phoneEmailOtpVerified: false,
    seconds: 60,
    displayTimer: false,
    emissionData: null,
};

const persistConfig = {
    storage,
    key: "v706-demo1-auth",
    whitelist: ["user", "authToken", "displayTimer"],
};

export const reducer = persistReducer(persistConfig, (state = initialState, action) => {
    switch (action.type) {

        case AuthMap.UPLOAD_DOCUMENT_START:
        case AuthMap.USER_BASIC_INFORMATION_START:
        case AuthMap.UPLOAD_PROFILE_IMAGE_START:
        case AuthMap.USER_LOGOUT_START:
        case AuthMap.USER_REGISTER_VERIFICATION_START:
        case AuthMap.USER_LOGIN_VERIFICATION_START:
        case AuthMap.USER_OTP_VERIFICATION_START:        
        case AuthMap.USER_REGISTER_START: {
            return {
                ...state,
                isLoading: true,
            }
        }

        case AuthMap.USER_REGISTER_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                user: action.payload,
                redirectRegisterVerification: true,
                flashMessage: "",
                displayTimer: false
            }
        }

        case AuthMap.USER_BASIC_INFORMATION_ERROR: {
            return {
                ...state,
                isLoading: false,
                flashMessage: action.payload || "",
            }
        }

        case AuthMap.USER_REGISTER_VERIFICATION_ERROR:
        case AuthMap.USER_REGISTER_ERROR: {
            return {
                ...state,
                isLoading: false,
                // user: null,
                authToken: null,
                // redirectRegisterVerification: false,
                // redirectRegisterProfilePage: false,
                flashMessage: action.payload || "",
            }
        }

        case AuthMap.USER_REGISTER_VERIFICATION_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                user: action.payload,
                token: action.payload.token,
                redirectRegisterProfilePage: true,
                authToken: action.payload.token,
                flashMessage: "",
            }
        }

        case AuthMap.USER_BASIC_INFORMATION_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                user: action.payload,
                redirectRegisterProfilePage: false,
                flashMessage: "",
            }
        }

        case AuthMap.LOGIN_START: {
            return {
                ...state,
                isLoading: true,
                verificationField: action.payload,
                displayTimer: false
            }
        }

        case AuthMap.LOGIN_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                user: action.payload,
                redirectLoginVerification: true,
                authToken: action.payload.token,
                flashMessage: ""
            }
        }

        case AuthMap.UPLOAD_PROFILE_IMAGE_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                user: action.payload,
                // authToken: action.payload.token,
                flashMessage: ""
            }
        }

        case AuthMap.USER_LOGIN_VERIFICATION_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                user: action.payload,
                redirectToDashboard: true,
                authToken: action.payload.token,
                flashMessage: "",
                verificationField: "",
                redirectLoginVerification: false,
            }
        }

        case AuthMap.USER_LOGIN_VERIFICATION_ERROR:
        case AuthMap.LOGIN_ERROR: {
            return {
                ...state,
                isLoading: false,
                authToken: null,
                flashMessage: action.payload || "",
            }
        }

        case AuthMap.RESET_INIT_AUTH_STATE:
        case AuthMap.USER_LOGOUT_SUCCESS:
        case AuthMap.USER_LOGOUT_ERROR: {
            return {
                ...initialState
            }
        }

        case AuthMap.UPLOAD_DOCUMENT_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                user: {
                    ...state.user,
                    ...action.payload
                },
                uploadDocumentModal: false,
            }
        }

        case AuthMap.UPLOAD_DOCUMENT_ERROR:
        case AuthMap.UPLOAD_PROFILE_IMAGE_ERROR: {
            return {
                ...state,
                isLoading: false,
            }
        }
        case AuthMap.FORGOT_PASSWORD_START: {
            return {
                ...state,
                isLoading: true,
            }
        }
        case AuthMap.FORGOT_PASSWORD_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                flashMessage: action.payload,
                redirectLoginVerification: true,
                errors: "",
            }
        }
        case AuthMap.SET_NEW_PASSWORD_START: {
            return {
                ...state,
                isLoading: true,
            }
        }
        case AuthMap.FORGOT_PASSWORD_ERROR:
        case AuthMap.SET_NEW_PASSWORD_SUCCESS:
        case AuthMap.SET_NEW_PASSWORD_ERROR: {
            return {
                ...state,
                isLoading: false,
            }
        }
        case AuthMap.CONTACT_US_START: {
            return {
                ...state,
                isLoading: true,
            }
        }
        case AuthMap.CONTACT_US_SUCCESS:
        case AuthMap.CONTACT_US_ERROR: {
            return {
                ...state,
                isLoading: false,
            }
        }
        case AuthMap.GET_ALL_CMS_PAGES_SUCCESS: {
            return {
                ...state,
                CMS: action.payload,
                backdrop: false,
            }
        }
        case AuthMap.GET_EMISSTION_DETAILS_SUCCESS: {
            return {
                ...state,
                emissionData: action.payload,
                backdrop: false,
            }
        }

        case AuthMap.GET_PROFILE_DASHBOARD_ERROR:
        case AuthMap.GET_EMISSTION_DETAILS_ERROR:
        case AuthMap.GET_ALL_CMS_PAGES_ERROR: {
            return {
                ...state,
                backdrop: false,
            }
        }
        case AuthMap.GET_PROFILE_DASHBOARD_START:
        case AuthMap.GET_ALL_CMS_PAGES_START:
        case AuthMap.GET_EMISSTION_DETAILS_START:
        case AuthMap.GET_CMS_DETAILS_START: {
            return {
                ...state,
                backdrop: true,
            }
        }
        case AuthMap.VERIFY_AUTH_TOKEN_SUCCESS: {
            return {
                ...state,
                tokenVerified: true,
                authToken: action.payload,
                user: {
                    ...state.user,
                    token: action.payload
                }
            }
        }
        case AuthMap.VERIFY_AUTH_TOKEN_ERROR: {
            return {
                ...initialState,
                tokenVerified: true
            }
        }

        case AuthMap.TOGGLE_UPLOAD_DOCUMENT_MODAL: {
            return {
                ...state,
                uploadDocumentModal: action.payload,
            }
        }

        case AuthMap.CONTACT_US_START:
        case AuthMap.CONTACT_US_SUCCESS:
        case AuthMap.CONTACT_US_ERROR: {
            return {
                ...state,
                isLoading: true
            }
        }

        case AuthMap.GET_PROFILE_DASHBOARD_SUCCESS: {
            return {
                ...state,
                backdrop: false,
                profileDashboard: action.payload
            }
        }

        case AuthMap.PHONE_EMAIL_OTP_START:{
            return {
                ...state,
                isLoading: false,
                displayTimer: true,
            }
        }
        case AuthMap.PHONE_EMAIL_OTP_SUCCESS: {
            return {
                ...state,
                user: action.payload,
                isLoading: false,
                displayTimer: true
            }
        }
        case AuthMap.PHONE_EMAIL_OTP_ERROR: {
            return {
                ...state,
                isLoading: false,
                displayTimer: false,
            }
        }

        case AuthMap.WALLETADDRESS_START: {
            return {
                ...state,
                walletAddress:action.payload
                
            }
        }
        case AuthMap.WALLETADDRESS_SUCCESS: {
            return {
                ...state,
                walletAddress:action.payload,
            }
        }
        case AuthMap.WALLETADDRESS_ERROR: {
            return {
                ...state,
                walletAddress:action.payload,
            }
        }

        
        case AuthMap.VERIFY_OTP_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                user: action.payload,
                phoneEmailOtpVerified: true,
            }
        }

        case AuthMap.VERIFY_OTP_ERROR: {
            return {
                ...state,
                isLoading: false,
                flashMessage: action.payload || "",
                phoneEmailOtpVerified: false,
            }
        }
    

        case AuthMap.GET_CMS_DETAILS_SUCCESS:
        case AuthMap.GET_CMS_DETAILS_ERROR:
        default: return { ...state }
    }


    

});